/**
 * CfssPayrollPage — Agency Admin Payroll Processing
 *
 * MN 256B.85: CFSS budget and agency model payroll
 * Thin wrapper around shared PayrollBatchPage with CFSS config.
 *
 * Route: /cfss/payroll
 */

import { PayrollBatchPage } from '@/pages/shared-services';

export function CfssPayrollPage() {
  return (
    <PayrollBatchPage
      title="CFSS Payroll"
      subtitle="Process approved timesheets into payroll runs"
      workerLabel="Worker"
      scope="payroll:run"
    />
  );
}

export default CfssPayrollPage;
